<template>
  <div class="pv-page">
    <div class="pv-head">
      <div class="pv-head__left">
        <router-link to="/predmeti" class="pv-head__back"><i class="el-icon-back"></i> Predmeti</router-link>
        <div class="pv-head__titlerow">
          <h1 class="pv-head__title">Predmet {{ formData.broj }}</h1>
          <StatusTag :value="formData.status" pill />
          <span v-if="phaseAge && !isClosed" class="pv-head__age" :class="phaseAgeClass">{{ phaseAge }} u fazi</span>
          <el-dropdown
            trigger="click"
            :disabled="isClosed || !nosioci.length"
            @command="changeNosioc"
          >
            <span class="nosioc" :class="{ 'nosioc--advokat': currentNosioc && currentNosioc.advokat, 'is-disabled': isClosed }">
              <span class="nosioc__label">Nosioc</span>
              {{ currentNosioc ? currentNosioc.naziv : "—" }}
              <i v-if="!isClosed" class="el-icon-arrow-down"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="n in nosioci"
                :key="n.id"
                :command="n.id"
                :disabled="n.id === formData.nosioc_id"
              >{{ n.naziv }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="pv-head__sub">
          Zaprimljen {{ formData.datum_prijema }}
          <template v-if="formData.owner && formData.owner.first_name">
            · zadužio {{ formData.owner.first_name }} {{ formData.owner.last_name }}
          </template>
        </div>
      </div>
      <div class="pv-head__actions">
        <el-button
          type="primary"
          :disabled="isClosed"
          @click="state.showUpdateStatusDialog = true"
        >Promijeni fazu</el-button>
      </div>
    </div>

    <el-tabs v-model="state.activeTab" @tab-click="handleTabClick">
      <el-tab-pane label="Predmet" name="predmet">
        <div class="pv">
          <div class="pv__main">
            <section class="card">
              <header class="card__head"><h2 class="card__title">Osnovni podaci</h2></header>
              <div class="grid grid--3">
                <div class="fieldv">
                  <span class="fieldv__label">Broj predmeta</span>
                  <span class="fieldv__value fieldv__value--strong">{{ formData.broj }}</span>
                </div>
                <div class="fieldv">
                  <span class="fieldv__label">Datum prijema</span>
                  <span class="fieldv__value">{{ formData.datum_prijema }}</span>
                </div>
                <div class="fieldv">
                  <span class="fieldv__label">Vrsta osiguranja</span>
                  <span class="fieldv__value">{{ formData.objects.vrsta_osiguranja["label"] || "—" }}</span>
                </div>
                <div class="fieldv fieldv--span2">
                  <span class="fieldv__label">
                    Obaveza
                    <el-button
                      v-if="!isClosed"
                      class="fieldv__edit"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      title="Uredi obaveze"
                      @click="state.showAddObavezaDialog = true"
                    ></el-button>
                  </span>
                  <span class="fieldv__value">
                    <template v-if="formData.objects.obaveza.length">
                      <el-tag
                        v-for="(o, i) in formData.objects.obaveza"
                        :key="i"
                        size="small"
                        class="fieldv__tag"
                      >{{ o.label }}</el-tag>
                    </template>
                    <span v-else class="fieldv__muted">—</span>
                  </span>
                </div>
                <div class="fieldv">
                  <span class="fieldv__label">
                    Saradnik
                    <el-button
                      v-if="!isClosed"
                      class="fieldv__edit"
                      icon="el-icon-edit"
                      size="mini"
                      circle
                      title="Uredi saradnika"
                      @click="state.showAddSradnikDialog = true"
                    ></el-button>
                  </span>
                  <span class="fieldv__value">
                    <template v-if="formData.objects.saradnik.ime">
                      {{ formData.objects.saradnik.ime }} {{ formData.objects.saradnik.prezime }}
                    </template>
                    <span v-else class="fieldv__muted">—</span>
                  </span>
                </div>
              </div>
            </section>

            <section class="card">
              <header class="card__head"><h2 class="card__title">Oštećeni i punomoćnici</h2></header>
              <div v-if="!state.optable.length" class="op-empty">Nema unesenih oštećenih</div>
              <ul v-else class="op-list">
                <li v-for="(op, i) in state.optable" :key="i" class="op-row">
                  <div class="op-row__party">
                    <span class="op-row__label">Oštećeni</span>
                    <span class="op-row__name">{{ op.osteceni.ime }} {{ op.osteceni.prezime }}</span>
                    <span class="op-row__meta">
                      <template v-if="op.osteceni.telefon && op.osteceni.telefon !== '0'">{{ op.osteceni.telefon }}</template>
                    </span>
                  </div>
                  <div v-if="op.punomocnik.id !== op.osteceni.id" class="op-row__party">
                    <span class="op-row__label">Punomoćnik</span>
                    <span class="op-row__name">{{ op.punomocnik.ime }} {{ op.punomocnik.prezime }}</span>
                    <span class="op-row__meta">
                      <template v-if="op.punomocnik.telefon && op.punomocnik.telefon !== '0'">{{ op.punomocnik.telefon }}</template>
                    </span>
                  </div>
                  <div v-else class="op-row__party op-row__party--muted">
                    <span class="op-row__label">Punomoćnik</span>
                    <span class="op-row__name">isti kao oštećeni</span>
                  </div>
                </li>
              </ul>
            </section>

            <section
              class="card"
              v-if="isVehicleVrsta && typeof formData.meta != 'undefined'"
            >
              <header class="card__head">
                <h2 class="card__title">Vozilo</h2>
                <el-button
                  v-if="!isClosed"
                  class="card__edit"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  title="Uredi podatke o vozilu"
                  @click="showAOMetaDialog"
                ></el-button>
              </header>
              <div class="grid grid--4">
                <div class="fieldv">
                  <span class="fieldv__label">Registarska oznaka</span>
                  <span class="fieldv__value">{{ formData.meta.registarska_oznaka || "—" }}</span>
                </div>
                <div class="fieldv">
                  <span class="fieldv__label">Godište</span>
                  <span class="fieldv__value">{{ formData.meta.godiste || "—" }}</span>
                </div>
                <div class="fieldv">
                  <span class="fieldv__label">Marka</span>
                  <span class="fieldv__value">{{ getBrendName(formData.meta.brend_id) || "—" }}</span>
                </div>
                <div class="fieldv">
                  <span class="fieldv__label">Model</span>
                  <span class="fieldv__value">{{ getAutoModelName(formData.meta.auto_model_id) || "—" }}</span>
                </div>
              </div>
            </section>

            <section class="card">
              <header class="card__head">
                <h2 class="card__title">Napomena</h2>
                <el-button
                  class="card__edit"
                  icon="el-icon-edit"
                  size="mini"
                  circle
                  title="Uredi napomenu"
                  @click="showUpdateNapomenaDialog"
                  :disabled="isClosed"
                ></el-button>
              </header>
              <pre v-if="state.renderNapomena && formData.napomena" class="napomena-text">{{ formData.napomena }}</pre>
              <div v-else class="fieldv__muted napomena-empty">Nema napomene</div>
            </section>
          </div>

          <aside class="pv__rail">
            <section class="card">
              <header class="card__head"><h2 class="card__title">Tok predmeta</h2></header>
              <ol v-if="timeline.length" class="tl">
                <li v-for="(e, i) in timeline" :key="e.key" class="tl__item">
                  <div class="tl__gutter">
                    <span class="tl__dot" :class="{ 'tl__dot--nosioc': e.kind === 'nosioc' }" :style="{ background: e.color }"></span>
                    <span v-if="i < timeline.length - 1" class="tl__line"></span>
                  </div>
                  <div class="tl__body">
                    <div class="tl__title">{{ e.title }}</div>
                    <div class="tl__meta">{{ dateTimeFormat(e.ts) }} · {{ e.username }}</div>
                    <div v-if="e.comment" class="tl__comment">{{ e.comment }}</div>
                  </div>
                </li>
              </ol>
              <div v-else class="fieldv__muted">Nema zabilježenih promjena</div>
            </section>

            <section class="card">
              <header class="card__head"><h2 class="card__title">Komentari</h2></header>
              <div class="comment-input-block">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder="Napišite komentar…"
                  v-model="formData.commentInput"
                ></el-input>
                <el-button
                  type="primary"
                  class="w100 comment-submit"
                  @click="postPredmetComment"
                  :disabled="isClosed || !formData.commentInput"
                >Objavi komentar</el-button>
              </div>
              <Comments :items="this.formData.komentari" />
            </section>
          </aside>
        </div>
      </el-tab-pane>
        <el-tab-pane label="Finansije" name="finansije">
        <div class="fin">
          <div class="fin-summary-bar">
            <div class="fsum">
              <span class="fsum__label">Zahtjev</span>
              <span class="fsum__value">{{ formatValue(finansije.zahtjev.lastv.toFixed(2)) }}<span class="fsum__unit">KM</span></span>
            </div>
            <i class="el-icon-right fsum__arrow"></i>
            <div class="fsum">
              <span class="fsum__label">Ponuda</span>
              <span class="fsum__value">{{ formatValue(finansije.ponuda.lastv.toFixed(2)) }}<span class="fsum__unit">KM</span></span>
            </div>
            <i class="el-icon-right fsum__arrow"></i>
            <div class="fsum">
              <span class="fsum__label">Naplaćeno</span>
              <span class="fsum__value">{{ formatValue(finansije.naplata.sum.toFixed(2)) }}<span class="fsum__unit">KM</span></span>
            </div>
            <div class="fsum__spacer"></div>
            <div class="fsum fsum--alt">
              <span class="fsum__label">Isplaćeno klijentu</span>
              <span class="fsum__value">{{ formatValue(isplaceno.toFixed(2)) }}<span class="fsum__unit">KM</span></span>
            </div>
            <div class="fsum fsum--result">
              <span class="fsum__label">{{ balanceLabel }}</span>
              <span class="fsum__value" :class="{ 'fsum__value--neg': balance < 0 && isClosed }">
                {{ formatValue(Math.abs(balance).toFixed(2)) }}<span class="fsum__unit">KM</span>
              </span>
            </div>
          </div>

          <div class="fin-cols">
            <section class="card">
              <header class="card__head">
                <h2 class="card__title">Potraživanje od osiguranja</h2>
                <span class="card__hint">novac koji ulazi</span>
              </header>
              <hist-val
                :meta="{ title: 'Iznos zahtjeva', unit: 'KM', value: finansije.zahtjev.lastv }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 0 }"
                :items="finansije.zahtjev.items"
                :callback="reloadFinansije"
                :closed="isClosed"
              ></hist-val>
              <hist-val
                :meta="{ title: 'Iznos ponude', unit: 'KM', value: finansije.ponuda.lastv }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 1 }"
                :items="finansije.ponuda.items"
                :callback="reloadFinansije"
                :closed="isClosed"
              ></hist-val>
              <hist-val
                :meta="{ title: 'Iznos naplaćeno', unit: 'KM', value: finansije.naplata.sum }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 3 }"
                :items="finansije.naplata.items"
                :callback="reloadFinansije"
                :closed="isClosed || !hasPermission('MANAGE_FINANSIJE')"
              ></hist-val>
            </section>

            <section class="card">
              <header class="card__head">
                <h2 class="card__title">Isplate klijentu</h2>
                <span class="card__hint">novac koji izlazi</span>
              </header>
              <hist-val
                :meta="{ title: 'Iznos klijent', unit: 'KM', value: finansije.klijent.sum }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 2 }"
                :items="finansije.klijent.items"
                :callback="reloadFinansije"
                :closed="isClosed || !hasPermission('MANAGE_FINANSIJE')"
              ></hist-val>
              <hist-val
                :meta="{ title: 'Otkup ponuda', unit: 'KM', value: finansije.otkup_ponuda.lastv }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 4 }"
                :items="finansije.otkup_ponuda.items"
                :callback="reloadFinansije"
                :closed="isClosed"
              ></hist-val>
              <hist-val
                :meta="{ title: 'Otkup plaćeno', unit: 'KM', value: finansije.otkup_placeno.sum }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 5 }"
                :items="finansije.otkup_placeno.items"
                :callback="reloadFinansije"
                :closed="isClosed"
              ></hist-val>
              <hist-val
                :meta="{ title: 'Avans klijentu', unit: 'KM', value: finansije.avans.sum }"
                :config="{ fin_id: this.formData.finansije_id, user_id: this.formData.user_id, type: 6 }"
                :items="finansije.avans.items"
                :callback="reloadFinansije"
                :closed="isClosed || !hasPermission('MANAGE_FINANSIJE')"
              ></hist-val>
            </section>
          </div>

          <section class="card">
            <header class="card__head"><h2 class="card__title">Komentari</h2></header>
            <div class="fin-comments">
              <div class="comment-input-block">
                <el-input
                  type="textarea"
                  :autosize="{ minRows: 2, maxRows: 5 }"
                  placeholder="Napišite komentar…"
                  v-model="formData.commentInput"
                ></el-input>
                <el-button
                  type="primary"
                  class="comment-submit"
                  @click="postComment"
                  :disabled="isClosed || !formData.commentInput"
                >Objavi komentar</el-button>
              </div>
              <Comments :items="this.finansije.komentari" />
            </div>
          </section>
        </div>
        </el-tab-pane>
    </el-tabs>
    <PhaseDialog
      :visible.sync="state.showUpdateStatusDialog"
      :predmet-id="formData.id"
      :predmet-broj="formData.broj"
      :current-status="formData.status"
      @updated="reloadStatus"
    />
    <el-dialog
      title="Update napomena"
      :visible.sync="state.showUpdateNapomenaDialog"
    >
      <el-form :model="state.napomenaForm">
        <el-form-item label="Napomena">
          <el-input
            v-model="state.napomenaForm.napomena"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 6 }"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.showUpdateNapomenaDialog = false"
          >Cancel</el-button
        >
        <el-button type="primary" @click="handleNapomenaUpdate"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="Dodaj saradnika"
      :visible.sync="state.showAddSradnikDialog"
    >
      <el-row>
        <el-col :span="20">
          <el-autocomplete
            class="inline-input w100"
            v-model="state.saradnik"
            :fetch-suggestions="fetchSradnik"
            placeholder="Saradnik"
            @select="selectSaradnikTmp"
          >
            <template slot-scope="item">
              {{ item.item.ime }} {{ item.item.prezime }}
              <span class="lowlight">- TEL: {{ item.item.telefon }}</span>
            </template>
          </el-autocomplete>
        </el-col>
        <el-col :span="4">
          <el-button icon="el-icon-plus" @click="showQuickSaradnik">
          </el-button>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.showAddSradnikDialog = false"
          >Cancel</el-button
        >
        <el-button type="primary" @click="updateSaradnik">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Dodijeli obavezu"
      :visible.sync="state.showAddObavezaDialog"
    >
      <el-row>
        <el-col :span="20">
          <el-select
            class="w100"
            multiple
            filterable
            v-model="state.obaveza"
            placeholder="Obaveza"
          >
            <el-option
              v-for="item in formContent.obaveza"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button icon="el-icon-plus" @click="showQuickObaveza"></el-button>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.showAddObavezaDialog = false"
          >Cancel</el-button
        >
        <el-button type="primary" @click="updateObaveza">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="Uredi podatke o vozilu"
      :visible.sync="state.showAddMetaDialog"
    >
      <el-row>
        <el-row>
          <el-col :span="12">
            <el-input
              v-model="state.metaForm.registarska_oznaka"
              autocomplete="off"
            >
              <template slot="prepend">Reg. Oznaka:</template>
            </el-input>
          </el-col>
          <el-col :span="12">
            <el-select
              class="w100"
              filterable
              v-model="state.metaForm.godiste"
              placeholder="Godište"
            >
              <el-option
                v-for="item in formContent.godista"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="10">
            <el-select
              class="w100"
              filterable
              v-model="state.metaForm.brend_id"
              placeholder="Marka"
              @change="handleFormBrendChange"
            >
              <el-option
                v-for="item in formContent.brend"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button icon="el-icon-plus" @click="showQuickBrend"></el-button>
          </el-col>
          <el-col :span="10">
            <el-select
              class="w100"
              filterable
              v-model="state.metaForm.auto_model_id"
              placeholder="Model"
              :disabled="state.metaForm.brend_id === undefined"
            >
              <el-option
                v-for="item in formMeta.auto_model"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="2">
            <el-button
              icon="el-icon-plus"
              @click="showQuickAutoModel"
              :disabled="state.metaForm.brend_id === undefined"
            ></el-button>
          </el-col>
        </el-row>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.showAddMetaDialog = false">Cancel</el-button>
        <el-button type="primary" @click="updateMeta">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog title="Novi Saradnik" :visible.sync="state.quickSaradnik">
      <el-form :model="state.saradnikForm">
        <el-form-item label="Ime*">
          <el-input
            v-model="state.saradnikForm.ime"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Prezime*">
          <el-input
            v-model="state.saradnikForm.prezime"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Adresa">
          <el-input
            v-model="state.saradnikForm.adresa"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Telefon*">
          <el-input
            v-model="state.saradnikForm.telefon"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input
            v-model="state.saradnikForm.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickSaradnik = false">Cancel</el-button>
        <el-button type="primary" @click="createSaradnik">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Novi Obveznik" :visible.sync="state.quickObaveza">
      <el-form :model="state.obavezaForm">
        <el-form-item label="Naziv*">
          <el-input
            v-model="state.obavezaForm.naziv"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Opis">
          <el-input
            v-model="state.obavezaForm.opis"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Adresa">
          <el-input
            v-model="state.obavezaForm.adresa"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Telefon">
          <el-input
            v-model="state.obavezaForm.telefon"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item label="Email">
          <el-input
            v-model="state.obavezaForm.email"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickObaveza = false">Cancel</el-button>
        <el-button type="primary" @click="createObaveza">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Nova Marka" :visible.sync="state.quickBrend">
      <el-form :model="state.brendForm">
        <el-form-item label="Naziv*">
          <el-input
            v-model="state.brendForm.naziv"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickBrend = false">Cancel</el-button>
        <el-button type="primary" @click="createBrend">Confirm</el-button>
      </span>
    </el-dialog>
    <el-dialog title="Novi Model" :visible.sync="state.quickAutoModel">
      <el-form :model="state.autoModelForm">
        <el-form-item label="Naziv*">
          <el-input
            v-model="state.autoModelForm.naziv"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="state.quickAutoModel = false">Cancel</el-button>
        <el-button type="primary" @click="createAutoModel">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import moment from "moment";
import API from "@/services/api/api";
import HistVal from "@/components/HistVal.vue";
import Comments from "@/components/Comments.vue";
import AuthService from "@/services/auth.service";
import DataService from "@/services/data.service";
import StatusTag from "@/components/StatusTag";
import { loadNosioci } from "@/models/nosioc";
import PhaseDialog from "@/components/PhaseDialog";
import { getStatus, getStatusLabel as sharedStatusLabel, STALE_DAYS, WARN_DAYS } from "@/models/status";

export default {
  name: "PredmetView",
  components: { HistVal, Comments, StatusTag, PhaseDialog },
  data() {
    return {
      vehicleVrste: [],
      finansije: {
        komentari: [],
        zahtjev: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
        ponuda: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
        klijent: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
        naplata: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
        otkup_ponuda: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
        otkup_placeno: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
        avans: {
          sum: 0,
          lastv: 0,
          items: [
            {
              content: "Start",
              value: 0.0,
              type: "info",
              user: "Admin",
            },
          ],
        },
      },
      formMeta: {
        auto_model: [],
      },
      state: {
        metaForm: {
          godiste: "",
        },
        obaveza: [],
        renderNapomena: true,
        api_url: "",
        showAddMetaDialog: false,
        showAddSradnikDialog: false,
        showAddObavezaDialog: false,
        showUpdateNapomenaDialog: false,
        showUpdateStatusDialog: false,
        activeStatusNames: [],
        activeTab: "predmet",
        kontaktForm: {},
        obavezaForm: {},
        brendForm: {},
        autoModelForm: {},
        saradnikForm: {},
        oeqp: true,
        // Declared up front: v-model on an undeclared property is not
        // reactive in Vue 2, so the field kept snapping back to the
        // previous saradnik and typing landed on the end of it.
        saradnik: "",
        osteceni: "",
        osteceni_obj: {},
        punomocnik: "",
        punomocnik_obj: {},
        optable: [],
        quickKontakt: false,
        quickObaveza: false,
        quickBrend: false,
        quickAutoModel: false,
        quickSaradnik: false,
        napomenaForm: {},
      },
      nosioci: [],
      formData: {
        godina: "",
        // Declared so they are reactive: loadPredmet fills them with plain
        // assignments, which Vue 2 only tracks on properties that exist.
        nosioc_id: null,
        nosioc_history: [],
        // Declared so it is reactive: it is filled in by loadPredmet with a
        // plain assignment, and the vehicle-section computed only re-runs
        // when a reactive dependency changes.
        vrsta_osiguranja: null,
        komentari: [],
        obaveza: [],
        datum_prijema: "",
        meta: {},
        objects: {
          vrsta_osiguranja: {},
          obaveza: [],
          saradnik: {},
        },
        status: -1,
        status_history: [],
        owner: {},
      },
      formContent: {
        vrsta_osiguranja: [],
        obaveza: [],
        godista: [],
        brend: [],
        auto_model: [],
        saradnik: [],
        kontakti: {},
      },
    };
  },
  computed: {
    currentNosioc() {
      return this.nosioci.find((n) => n.id === this.formData.nosioc_id) || null;
    },
    // Phase changes and changes of nosioc, newest first, read as one history.
    timeline() {
      const phases = (this.formData.status_history || []).map((s) => ({
        kind: "faza",
        key: "f" + s.id,
        ts: s.timestamp,
        title: this.getStatusLabel(s.status_id),
        color: this.statusColor(s.status_id),
        username: s.username,
        comment: s.comment,
      }));
      const owners = (this.formData.nosioc_history || []).map((n) => ({
        kind: "nosioc",
        key: "n" + n.id,
        ts: n.timestamp,
        title: "Nosioc: " + n.naziv,
        color: "#0f766e",
        username: n.username,
        comment: n.comment,
      }));
      return phases.concat(owners).sort((a, b) => new Date(b.ts) - new Date(a.ts));
    },
    isVehicleVrsta() {
      return this.vehicleVrste.indexOf(this.formData.vrsta_osiguranja) !== -1;
    },
    isClosed() {
      return this.formData.status == 10 || this.formData.status == -1;
    },
    // Days since the case entered its current phase (history is newest first).
    daysInPhase() {
      const h = this.formData.status_history;
      if (!h || !h.length) return null;
      return moment().diff(moment(h[0].timestamp), "days");
    },
    phaseAge() {
      const d = this.daysInPhase;
      if (d === null) return "";
      if (d === 0) return "danas";
      return d === 1 ? "1 dan" : d + " dana";
    },
    balance() {
      return this.finansije.naplata.sum - this.isplaceno;
    },
    // Exactly one of profit/potraživanje is ever meaningful, so show that one
    // rather than a pair where the other is always clamped to zero.
    balanceLabel() {
      if (this.isClosed) return "Profit";
      return this.balance < 0 ? "Potraživanje" : "Profit";
    },
    isplaceno() {
      const f = this.finansije;
      return f.klijent.sum + f.otkup_placeno.sum + f.avans.sum;
    },
    potrazivanje() {
      const f = this.finansije;
      return Math.max(f.klijent.sum + f.otkup_placeno.sum + f.avans.sum - f.naplata.sum, 0);
    },
    profit() {
      const f = this.finansije;
      const raw = f.naplata.sum - (f.klijent.sum + f.otkup_placeno.sum + f.avans.sum);
      // While the case is open, an unfinished balance is not a loss yet.
      return this.formData.status == 10 ? raw : Math.max(raw, 0);
    },
    phaseAgeClass() {
      const d = this.daysInPhase;
      if (d === null || this.isClosed) return "";
      if (d >= STALE_DAYS) return "pv-head__age--stale";
      if (d >= WARN_DAYS) return "pv-head__age--warn";
      return "";
    },
  },
  methods: {
    formatValue: function (nStr) {
      nStr += "";
      var x = nStr.split(".");
      var x1 = x[0];
      var x2 = x.length > 1 ? "." + x[1] : "";
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, "$1" + "," + "$2");
      }
      return x1 + x2;
    },
    showAOMetaDialog: function () {
      this.state.metaForm.brend_id = this.formData.meta.brend_id;
      this.state.metaForm.auto_model_id = this.formData.meta.auto_model_id;
      this.state.metaForm.registarska_oznaka = this.formData.meta.registarska_oznaka;
      this.state.metaForm.godiste = this.formData.meta.godiste;
      this.loadFormAutoModel();
      this.state.showAddMetaDialog = true;
    },
    hasPermission: function (p) {
      return AuthService.hasPermission(p);
    },
    updateMeta: function () {
      console.log(JSON.stringify(this.state.metaForm));
      var req = {
        predmet_id: this.formData.id,
        registarska_oznaka: this.state.metaForm.registarska_oznaka || "",
        brend_id: this.state.metaForm.brend_id,
        auto_model_id: this.state.metaForm.auto_model_id,
      };

      if (
        typeof this.state.metaForm.godiste != undefined &&
        this.state.metaForm.godiste != null
      ) {
        req["godiste"] = parseInt(this.state.metaForm.godiste, 10);
      } else {
        req["godiste"] = 0;
      }
      console.log(JSON.stringify(req));

      API.Generic.update("predmet/meta/ao", req)
        .then((data) => {
          console.log(data);
          this.state.showAddMetaDialog = false;
          this.formData.meta.brend_id = this.state.metaForm.brend_id;
          this.formData.meta.auto_model_id = this.state.metaForm.auto_model_id;
          this.formData.meta.registarska_oznaka = this.state.metaForm.registarska_oznaka;
          this.formData.meta.godiste = this.state.metaForm.godiste;
          this.loadAutoModel();
        })
        .catch((e) => {
          console.log(e);
        });
    },
    updateObaveza: function () {
      console.log(this.state.obaveza);
      // if (this.state.obaveza.length == 0) {
      //   return;
      // }

      API.Generic.update("predmet/obaveza", {
        predmet_id: this.formData.id,
        obaveza_id: this.state.obaveza,
      })
        .then((data) => {
          console.log(data);
          this.state.showAddObavezaDialog = false;
          this.formData.obaveza = this.state.obaveza;
          this.formData.objects.obaveza = [];
          this.formContent.obaveza.forEach((o) => {
            if (this.formData.obaveza.findIndex((x) => x == o.value) >= 0) {
              this.formData.objects.obaveza.push(o);
            }
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    async changeNosioc(id) {
      if (id === this.formData.nosioc_id) return;
      try {
        const res = await API.Generic.update("predmet/nosioc", {
          predmet_id: this.formData.id,
          nosioc_id: id,
        });
        const d = res.data.data;
        this.formData.nosioc_id = d.nosioc_id;
        this.formData.nosioc_history = d.nosioc_history || [];
        this.$message({ message: "Nosioc je promijenjen.", type: "success" });
      } catch (e) {
        console.log(e);
        this.$message({ message: "Nosioc nije promijenjen — pokušajte ponovo.", type: "error" });
      }
    },
    updateSaradnik: function () {
      console.log(this.formData.saradnik);
      if (typeof this.formData.saradnik == "undefined") {
        return;
      }

      API.Generic.update("predmet/saradnik", {
        predmet_id: this.formData.id,
        id: this.formData.saradnik,
      })
        .then((data) => {
          console.log(data);
          this.state.showAddSradnikDialog = false;
          this.getSaradnik(this.formData.saradnik);
        })
        .catch((e) => {
          console.log(e);
        });
    },
    getAutoModelName: function (id) {
      if (typeof id == "undefined") {
        return "";
      }
      let res = "N/A";
      this.formContent.auto_model.forEach((model) => {
        if (model.value && model.value.toString() == id.toString()) {
          res = model.label;
          return;
        }
      });
      return res;
    },
    getBrendName: function (id) {
      if (typeof id == "undefined") {
        return "";
      }
      let res = "N/A";
      this.formContent.brend.forEach((model) => {
        if (model.value && model.value.toString() == id.toString()) {
          res = model.label;
          return;
        }
      });
      return res;
    },
    reloadNapomena: async function () {
      var id = this.$route.params.id;
      return API.Generic.get("predmet", id)
        .then(async (data) => {
          let d = data.data.data;
          this.formData.napomena = d.napomena;
          this.state.renderNapomena = false;
          this.$nextTick(() => {
            // Add the component back in
            this.state.renderNapomena = true;
          });
        })
        .catch((e) => {
          console.log(e);
        });
    },
    handleNapomenaUpdate: async function () {
      console.log("napomena update", this.state.napomenaForm);
      if (typeof this.state.napomenaForm.napomena == "undefined") {
        return;
      }
      await API.Generic.update("predmet/napomena", {
        predmet_id: this.formData.id,
        napomena: this.state.napomenaForm.napomena,
      });
      this.state.showUpdateNapomenaDialog = false;
      this.reloadNapomena();
    },
    showUpdateNapomenaDialog: function () {
      this.state.napomenaForm = {};
      this.state.showUpdateNapomenaDialog = true;
    },
    getToken: AuthService.getToken,
    getAPI: DataService.api,
    handleClick: () => {},
    handleStatusCollapseChange: () => {},
    handleTabClick: (tab, event) => {
      console.log(tab, event);
    },
    postComment: async function () {
      console.log("postComment", this.formData.commentInput);
      if (
        typeof this.formData.commentInput == "undefined" ||
        this.formData.commentInput == ""
      ) {
        console.log("empty comment");
        return;
      }
      try {
        let commentForm = {
          comment: this.formData.commentInput,
          user_id: this.formData.user_id,
          parent_type: 1,
          parent_id: this.formData.finansije_id,
        };
        await API.Generic.create("komentar", commentForm);
        this.formData.commentInput = "";
        this.reloadFinansije();
      } catch (e) {
        console.log(e);
      }
    },
    postPredmetComment: async function () {
      console.log("postPredmetComment", this.formData.commentInput);
      if (
        typeof this.formData.commentInput == "undefined" ||
        this.formData.commentInput == ""
      ) {
        console.log("empty comment");
        return;
      }
      try {
        let commentForm = {
          comment: this.formData.commentInput,
          user_id: this.formData.user_id,
          parent_type: 2,
          parent_id: this.formData.id,
        };
        await API.Generic.create("komentar", commentForm);
        this.formData.commentInput = "";
        this.loadKomentari();
      } catch (e) {
        console.log(e);
      }
    },
    handleBrendChange: function () {
      delete this.formData.meta.auto_model_id;
      this.loadAutoModel();
    },
    handleFormBrendChange: function () {
      delete this.state.metaForm.auto_model_id;
      this.loadFormAutoModel();
    },
    reloadStatus: async function () {
      var id = this.$route.params.id;
      return API.Generic.get("predmet", id)
        .then(async (data) => {
          let d = data.data.data;
          this.formData.status = d.status;
          this.formData.status_history = d.status_history;
          this.formData.nosioc_id = d.nosioc_id;
          this.formData.nosioc_history = d.nosioc_history || [];
        })
        .catch((e) => {
          console.log(e);
        });
    },
    // handleSubmit: async function () {
    //   let req = {
    //     datum_prijema: moment().utcOffset(0, true).format(),
    //     godina: parseInt(this.formData.godina, 10),
    //     meta: global.toObject(this.formData.meta),
    //     napomena: this.formData.napomena,
    //     obaveza_id: this.formData.obaveza,
    //     saradnik_id: this.formData.saradnik,
    //     vrsta_osiguranja_id: this.formData.vrsta_osiguranja,
    //     osteceni_ids: [],

    //     // compatibility fields
    //     broj: "",
    //     osteceni_id: 0,
    //     punomocnik_id: 0,
    //   };

    //   this.state.optable.forEach((op) => {
    //     req.osteceni_ids.push({
    //       oid: op.osteceni.id,
    //       pid: op.punomocnik.id,
    //     });
    //   });
    //   console.log(req);
    //   try {
    //     await API.Generic.create("predmet", req);
    //     this.$router.push("/");
    //   } catch (e) {
    //     console.log(e);
    //   }
    // },
    showQuickKontakt: function () {
      this.state.kontaktForm = {};
      this.state.quickKontakt = true;
    },
    createKontakt: async function () {
      console.log("createKontakt", this.state.kontaktForm);
      try {
        await API.Generic.create("kontakt", this.state.kontaktForm);
        this.state.quickKontakt = false;
      } catch (e) {
        console.log(e);
      }
    },
    showQuickSaradnik: function () {
      this.state.saradnikForm = {};
      this.state.quickSaradnik = true;
    },
    createSaradnik: async function () {
      console.log("createSradnik", this.state.saradnikForm);
      try {
        await API.Generic.create("saradnik", this.state.saradnikForm);
        this.state.quickSaradnik = false;
      } catch (e) {
        console.log(e);
      }
    },
    showQuickAutoModel: function () {
      this.state.autoModelForm = {};
      this.state.quickAutoModel = true;
    },
    createAutoModel: async function () {
      try {
        await API.Generic.create("auto_model", {
          ...this.state.autoModelForm,
          brend_id: this.state.metaForm.brend_id,
        });
        this.state.quickAutoModel = false;
        delete this.state.metaForm.auto_model_id;
        this.loadAutoModel();
        this.loadFormAutoModel();
      } catch (e) {
        console.log(e);
      }
    },
    showQuickBrend: function () {
      this.state.brendForm = {};
      this.state.quickBrend = true;
    },
    createBrend: async function () {
      try {
        await API.Generic.create("brend", this.state.brendForm);
        this.state.quickBrend = false;
        delete this.formData.meta.auto_model_id;
        delete this.formData.meta.brend_id;
        this.loadBrend();
      } catch (e) {
        console.log(e);
      }
    },
    showQuickObaveza: function () {
      this.state.obavezaForm = {};
      this.state.quickObaveza = true;
    },
    createObaveza: async function () {
      console.log("createObaveza", this.state.obavezaForm);
      try {
        await API.Generic.create("obaveza", this.state.obavezaForm);
        await this.loadObaveza();
        this.state.quickObaveza = false;
      } catch (e) {
        console.log(e);
      }
    },
    addOP: function () {
      if (this.state.osteceni !== "" && this.state.punomocnik !== "") {
        let duplicate = false;
        this.state.optable.forEach((op) => {
          if (
            op.osteceni.id === this.state.osteceni_obj.id &&
            op.punomocnik.id === this.state.punomocnik_obj.id
          ) {
            duplicate = true;
            return;
          }
        });
        if (duplicate) {
          return;
        }
        this.state.optable.push({
          osteceni: this.state.osteceni_obj,
          punomocnik: this.state.punomocnik_obj,
        });
        this.state.osteceni_obj = {};
        this.state.osteceni = "";
        this.state.punomocnik_obj = {};
        this.state.punomocnik = "";
      }
    },
    deleteOP: function (oid, pid) {
      for (var i = 0; i < this.state.optable.length; i++) {
        if (
          this.state.optable[i].osteceni.id === oid &&
          this.state.optable[i].punomocnik.id === pid
        ) {
          this.state.optable.splice(i, 1);
        }
      }
    },
    maybeEqualizeOP: function () {
      if (this.state.oeqp) {
        this.state.punomocnik = this.state.osteceni;
        this.state.punomocnik_obj = this.state.osteceni_obj;
      }
    },
    selectOsteceni: function (item) {
      console.log(item);
      this.state.osteceni = item.ime + " " + item.prezime;
      this.state.osteceni_obj = item;
      this.maybeEqualizeOP();
    },
    selectSaradnikTmp: function (item) {
      console.log(item);
      // this.formData.objects.saradnik = item;
      this.formData.saradnik = item.id;
      this.state.saradnik = item.ime + " " + item.prezime;
    },
    selectSaradnik: function (item) {
      console.log(item);
      this.formData.objects.saradnik = item;
      this.formData.saradnik = item.id;
      this.state.saradnik = item.ime + " " + item.prezime;
    },
    selectPunomocnik: function (item) {
      this.state.punomocnik = item.ime + " " + item.prezime;
      this.state.punomocnik_obj = item;
    },
    fetchKontakt: async function (q, done) {
      try {
        let res = await API.Generic.search("kontakt", q);
        let kontakti = res.data.data.results;
        done(kontakti);
      } catch (e) {
        console.log(e);
      }
    },
    fetchSradnik: async function (q, done) {
      try {
        let res = await API.Generic.search("saradnik", q);
        let s = res.data.data.results;
        done(s);
      } catch (e) {
        console.log(e);
      }
    },
    getSaradnik: async function (id) {
      if (id) {
        try {
          let res = await API.Generic.get("saradnik", id);
          let s = res.data.data;
          this.selectSaradnik(s);
        } catch (e) {
          console.log(e);
        }
      } else {
        console.log("no saradnik");
      }
    },
    loadBrend: async function () {
      return API.Generic.all("brend")
        .then((data) => {
          let d = data.data.data;
          this.formContent.brend = [];
          d.results.forEach((o) => {
            this.formContent.brend.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadAutoModel: async function () {
      return API.Generic.all("auto_model", {
        brend_id: { val: this.formData.meta.brend_id },
      })
        .then((data) => {
          let d = data.data.data;
          this.formContent.auto_model = [];
          d.results.forEach((o) => {
            this.formContent.auto_model.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadFormAutoModel: async function () {
      return API.Generic.all("auto_model", {
        brend_id: { val: this.state.metaForm.brend_id },
      })
        .then((data) => {
          let d = data.data.data;
          this.formMeta.auto_model = [];
          d.results.forEach((o) => {
            this.formMeta.auto_model.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadGodista: function () {
      var years = [];
      var currentDate = new Date();
      var currentYear = currentDate.getFullYear();
      for (var i = 0; i < 50; i++) {
        var strYear = (currentYear - i).toString();
        years.push({ id: strYear, name: strYear });
      }
      this.formContent.godista = years;
    },
    loadObaveza: async function () {
      return API.Generic.all("obaveza")
        .then((data) => {
          let d = data.data.data;
          this.formContent.obaveza = [];
          d.results.forEach((o) => {
            this.formContent.obaveza.push({
              value: o.id,
              label: o.naziv,
            });
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadVrstaOsiguranja: async function () {
      return API.Generic.all("vrsta_osiguranja")
        .then((data) => {
          let d = data.data.data;
          d.results.forEach((o) => {
            this.formContent.vrsta_osiguranja.push({
              value: o.id,
              label: o.naziv,
            });
            // Which types carry a vehicle comes from the data, so inserting
            // a type into the middle of the list cannot get it wrong.
            if (o.vozilo) this.vehicleVrste.push(o.id);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadKontakts: async function (ids) {
      return API.Kontakti.many(ids)
        .then((data) => {
          let d = data.data.data;
          d.results.forEach((o) => {
            this.formContent.kontakti[o.id] = o;
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reloadFinansije: function () {
      this.loadFinansije(this.formData.finansije_id);
    },
    loadFinansije: async function (id) {
      return API.Generic.get("finansije", id)
        .then((data) => {
          let d = data.data.data;
          console.log("Finansije RESPONSE", d);
          this.finansije.zahtjev = d.zahtjev;
          this.finansije.ponuda = d.ponuda;
          this.finansije.klijent = d.klijent;
          this.finansije.naplata = d.naplata;
          this.finansije.otkup_ponuda = d.otkup_ponuda;
          this.finansije.otkup_placeno = d.otkup_placeno;
          this.finansije.avans = d.avans;
          this.finansije.komentari = d.komentari;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadKomentari: async function () {
      return (
        API.Generic.all("komentar", {
          parent_type: { val: 2 },
          parent_id: { val: this.formData.id },
        })
          // return API.Generic.get("komentar", id)
          .then((data) => {
            let d = data.data.data;
            console.log("Komentari RESPONSE", d);
            this.formData.komentari = d.results;
            // this.finansije.zahtjev = d.zahtjev;
            // this.finansije.ponuda = d.ponuda;
            // this.finansije.klijent = d.klijent;
            // this.finansije.naplata = d.naplata;
            // this.finansije.otkup_ponuda = d.otkup_ponuda;
            // this.finansije.otkup_placeno = d.otkup_placeno;
            // this.finansije.avans = d.avans;
            // this.finansije.komentari = d.komentari;
          })
          .catch((err) => {
            console.log(err);
          })
      );
    },
    statusColor: function (status_id) {
      return getStatus(status_id).dot;
    },
    getStatusLabel: function (status_id) {
      return sharedStatusLabel(status_id);
    },
    dateTimeFormat: function (date) {
      if (typeof date == "undefined") {
        return "";
      }
      return moment(date).format("DD/MM/YYYY HH:mm");
    },
    loadPredmet: async function () {
      var id = this.$route.params.id;
      return API.Generic.get("predmet", id)
        .then(async (data) => {
          let d = data.data.data;
          console.log(d);
          this.formData.broj = d.broj;
          this.formData.datum_prijema = moment(d.datum_prijema).format(
            "DD/MM/YYYY"
          );
          this.formData.godina = d.godina;
          this.formData.id = d.id;
          this.formData.napomena = d.napomena;
          this.formData.obaveza = d.obaveza;
          this.formData.saradnik = d.saradnik_id;
          this.formData.vrsta_osiguranja = d.vrsta_osiguranja_id;
          this.formData.meta = d.meta;
          this.formData.finansije_id = d.finansije_id;
          this.formData.status = d.status;
          this.formData.status_history = d.status_history;
          this.formData.nosioc_id = d.nosioc_id;
          this.formData.nosioc_history = d.nosioc_history || [];
          this.formData.owner = d.owner;

          let user = AuthService.getUser();
          this.formData.user_id = user.id;

          let kontaktIds = new Set();
          d.osteceni_ids.forEach((oip) => {
            kontaktIds.add(oip.oid);
            kontaktIds.add(oip.pid);
          });

          await this.loadKontakts(Array.from(kontaktIds));

          d.osteceni_ids.forEach((oip) => {
            this.state.optable.push({
              osteceni: this.formContent.kontakti[oip.oid],
              punomocnik: this.formContent.kontakti[oip.pid],
            });
          });

          this.formContent.vrsta_osiguranja.forEach((vo) => {
            if (vo.value == this.formData.vrsta_osiguranja) {
              this.formData.objects.vrsta_osiguranja = vo;
            }
          });

          this.formContent.obaveza.forEach((o) => {
            if (this.formData.obaveza.findIndex((x) => x == o.value) >= 0) {
              this.formData.objects.obaveza.push(o);
            }
          });

          this.getSaradnik(this.formData.saradnik);
          this.loadAutoModel();
          this.loadKomentari();
          this.loadFinansije(this.formData.finansije_id);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  created() {
    this.state.api_url = DataService.api();
    loadNosioci()
      .then((list) => (this.nosioci = list))
      .catch((e) => console.log(e));
    this.loadVrstaOsiguranja();
    this.loadObaveza();
    this.loadGodista();
    this.loadBrend();
    this.loadPredmet();
  },
};
</script>

<style lang="scss" scoped>
.pv-page {
  flex-grow: 1;
  min-height: 0;
  overflow-y: auto;
}

.pv-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 6px;
}

.pv-head__back {
  font-size: var(--fs-sm);
  color: var(--ink-3);
  text-decoration: none;

  &:hover {
    color: var(--brand-ink);
  }
}

.pv-head__titlerow {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-top: 3px;
  flex-wrap: wrap;
}

.pv-head__title {
  font-size: var(--fs-title);
  font-weight: 700;
  color: var(--ink);
  margin: 0;
}

.nosioc {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 3px 10px;
  border: 1px solid var(--line-strong);
  border-radius: 999px;
  font-size: var(--fs-sm);
  color: var(--ink-2);
  background: var(--surface);
  cursor: pointer;

  &.nosioc--advokat {
    background: #e6f4f1;
    border-color: #b5ddd6;
    color: #0f5e57;
    font-weight: 600;
  }

  &.is-disabled {
    cursor: default;
  }
}

.nosioc__label {
  font-size: var(--fs-2xs);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--ink-4);
  font-weight: 500;
}

.tl__dot--nosioc {
  border-radius: 2px;
}

.pv-head__age {
  font-size: var(--fs-sm);
  color: var(--ink-3);
}

.pv-head__age--warn {
  color: #8a6d0b;
  font-weight: 500;
}

.pv-head__age--stale {
  color: var(--danger);
  font-weight: 600;
}

.pv-head__sub {
  font-size: var(--fs-sm);
  color: var(--ink-3);
  margin-top: 4px;
}

.pv {
  display: flex;
  align-items: flex-start;
  gap: 14px;
}

.pv__main {
  flex-grow: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.pv__rail {
  width: 380px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.card {
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  padding: 20px 22px;
}

.card__head {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
}

.card__title {
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--ink);
  margin: 0;
}

.card__edit {
  margin-left: auto;
}

.grid {
  display: grid;
  gap: 14px 20px;
}

.grid--3 {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.grid--4 {
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.fieldv {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.fieldv--span2 {
  grid-column: span 2;
}

.fieldv__label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: var(--fs-xs);
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.fieldv__edit {
  padding: 3px;
  min-height: 0;
}

.fieldv__value {
  font-size: var(--fs-md);
  font-weight: 500;
  color: var(--ink);
  overflow-wrap: anywhere;
}

.fieldv__value--strong {
  font-size: var(--fs-xl);
  font-weight: 700;
  font-variant-numeric: tabular-nums;
}

.fieldv__tag {
  margin-right: 4px;
  margin-bottom: 2px;
}

.fieldv__muted {
  color: var(--ink-4);
  font-weight: 400;
  font-size: var(--fs-md);
}

.op-empty {
  padding: 18px;
  border: 1px dashed var(--line-strong);
  border-radius: var(--r-md);
  text-align: center;
  font-size: var(--fs-md);
  color: var(--ink-4);
}

.op-list {
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid var(--line);
  border-radius: var(--r-md);
  overflow: hidden;
}

.op-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
  gap: 16px;
  padding: 10px 14px;

  & + & {
    border-top: 1px solid var(--line-soft);
  }
}

.op-row__party {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.op-row__party--muted .op-row__name {
  color: var(--ink-4);
  font-weight: 400;
  font-style: italic;
}

.op-row__label {
  font-size: var(--fs-xs);
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.op-row__name {
  font-size: var(--fs-md);
  font-weight: 500;
  color: var(--ink);
}

.op-row__meta {
  font-size: var(--fs-sm);
  color: var(--ink-3);
}

.napomena-text {
  margin: 0;
  font-family: inherit;
  font-size: var(--fs-md);
  line-height: 1.55;
  color: var(--ink-2);
  white-space: pre-wrap;
  word-break: break-word;
}

.napomena-empty {
  font-style: italic;
}

.tl {
  list-style: none;
  margin: 0;
  padding: 0;
}

.tl__item {
  display: flex;
  gap: 10px;
}

.tl__gutter {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 10px;
  flex-shrink: 0;
}

.tl__dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  margin-top: 4px;
  flex-shrink: 0;
}

.tl__line {
  width: 2px;
  flex-grow: 1;
  background: var(--line);
  margin: 3px 0;
}

.tl__body {
  padding-bottom: 14px;
  min-width: 0;
}

.tl__title {
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--ink);
}

.tl__meta {
  font-size: var(--fs-sm);
  color: var(--ink-4);
  margin-top: 1px;
}

.tl__comment {
  font-size: var(--fs-sm);
  color: var(--ink-2);
  margin-top: 4px;
  background: var(--surface-alt);
  border-radius: var(--r-sm);
  padding: 6px 9px;
  white-space: pre-wrap;
}

.fin {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.fin-summary-bar {
  display: flex;
  align-items: center;
  gap: 28px;
  row-gap: 16px;
  background: var(--surface);
  border: 1px solid var(--line);
  border-radius: var(--r-lg);
  padding: 18px 22px;
  flex-wrap: wrap;
}

.fsum {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}

.fsum__label {
  font-size: var(--fs-xs);
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
  white-space: nowrap;
}

.fsum__value {
  font-size: var(--fs-2xl);
  font-weight: 700;
  color: var(--ink);
  font-variant-numeric: tabular-nums;
  white-space: nowrap;
}

.fsum__value--neg {
  color: var(--danger);
}

.fsum__unit {
  font-size: var(--fs-xs);
  font-weight: 500;
  color: var(--ink-3);
  margin-left: 4px;
}

.fsum__arrow {
  color: var(--ink-4);
  font-size: var(--fs-xl);
  margin-top: 12px;
}

.fsum__spacer {
  flex-grow: 1;
  min-width: 10px;
}

.fsum--alt .fsum__value {
  color: var(--ink-2);
}

.fsum--result {
  padding-left: 28px;
  border-left: 1px solid var(--line);
}

.fin-cols {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 18px;
  align-items: start;
}

.fin-comments {
  // The card is full width; only the composer needs a capped measure.
  max-width: none;
}

.ph__current {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: var(--fs-sm);
  color: var(--ink-3);
  margin-bottom: 14px;
}

.ph__list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  margin-bottom: 16px;
}

.ph__opt {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 9px 12px;
  background: none;
  border: 1px solid transparent;
  border-radius: var(--r-md);
  font: inherit;
  font-size: var(--fs-md);
  color: var(--ink);
  text-align: left;
  cursor: pointer;

  &:hover:not(:disabled) {
    background: var(--surface-alt);
  }

  &.is-selected {
    background: var(--brand-tint);
    border-color: var(--brand-line);
    color: var(--brand-ink);
    font-weight: 600;
  }

  &:disabled {
    cursor: default;
    color: var(--ink-4);
  }
}

.ph__opt--terminal {
  margin-top: 6px;
  border-top: 1px solid var(--line-soft);
  border-radius: 0 0 var(--r-md) var(--r-md);
  padding-top: 12px;
}

.ph__dot {
  width: 9px;
  height: 9px;
  border-radius: 50%;
  flex-shrink: 0;
}

.ph__name {
  flex-grow: 1;
}

.ph__badge {
  font-size: var(--fs-xs);
  color: var(--ink-4);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.ph__check {
  color: var(--brand);
  font-weight: 700;
}

.ph__field {
  margin-bottom: 14px;

  label {
    display: block;
    font-size: var(--fs-sm);
    color: var(--ink-2);
    margin-bottom: 5px;
  }
}

.dlg__err {
  font-size: var(--fs-sm);
  color: var(--danger);
  margin-bottom: 6px;
}

.req {
  color: var(--danger);
}

.comment-input-block {
  margin-bottom: 18px;
  max-width: 720px;
}

.comment-submit {
  margin-top: 10px;
}

.w100 {
  width: 100%;
}

.pf-header {
  font-size: var(--fs-lg);
  font-weight: 600;
  color: var(--ink);
  margin-bottom: 10px;
}

.predmeti-create-row {
  margin-bottom: 12px;
}

.padded-row {
  padding: 0 8px;
}

.lowlight {
  font-size: var(--fs-sm);
  color: var(--ink-4);
}

.fat-predmet-broj {
  font-weight: 700;
}
</style>
